import { Link } from 'react-router';
import { ROUTES } from '@/app/router/routes';
import { ArrowRightIcon, ChevronRightIcon, GlobeIcon, UsersIcon } from '@/components/icons';
import { CURRENCIES, useCurrency } from '@/lib/currency';
import './Settings.css';

export const SettingsPage = () => (
  <div className="settings-page">
    <header className="settings-heading">
      <span className="settings-eyebrow">Configuration</span>
      <h1>Paramètres</h1>
      <p>Votre compte et les préférences communes à votre entreprise.</p>
    </header>
    <div className="settings-grid">
      {[
        {
          title: 'Mon compte',
          description: 'Mettez à jour votre téléphone et votre mot de passe.',
          icon: UsersIcon,
          to: ROUTES.account,
        },
        {
          title: 'Préférences de l’entreprise',
          description: 'Consultez la devise de référence choisie par votre administrateur.',
          icon: GlobeIcon,
          to: ROUTES.preferences,
        },
      ].map(({ title, description, icon: Icon, to }) => (
        <Link className="settings-card" to={to} key={to}>
          <span className="settings-card-icon" aria-hidden>
            <Icon />
          </span>
          <span className="settings-card-content">
            <h2>{title}</h2>
            <p>{description}</p>
          </span>
          <ArrowRightIcon className="settings-card-arrow" />
        </Link>
      ))}
    </div>
  </div>
);
export const PreferencesPage = () => {
  const currency = useCurrency();
  return (
    <div className="settings-page">
      <nav className="settings-breadcrumb" aria-label="Fil d’Ariane">
        <Link to={ROUTES.settings}>Paramètres</Link>
        <ChevronRightIcon />
        <span>Préférences de l’entreprise</span>
      </nav>
      <header className="settings-heading">
        <h1>Préférences de l’entreprise</h1>
        <p>Ces réglages sont gérés par votre administrateur.</p>
      </header>
      <section className="settings-preferences" aria-label="Devise de référence">
        <div className="settings-preferences-heading">
          <span className="settings-card-icon" aria-hidden>
            <GlobeIcon />
          </span>
          <div>
            <h2>Devise de référence</h2>
            <p>{CURRENCIES.find((entry) => entry.value === currency)?.label ?? currency}</p>
          </div>
          <span className="settings-scope">Toute l’entreprise</span>
        </div>
        <div className="settings-preferences-body">
          <p className="settings-help">
            La devise s’applique aux nouveaux montants de la plateforme. Les documents et missions
            existants conservent leur devise enregistrée. Pour une modification, contactez votre
            administrateur.
          </p>
          <div className="settings-preview">
            <span>Aperçu d’un montant</span>
            <strong>
              {new Intl.NumberFormat('fr-FR', { style: 'currency', currency }).format(1250)}
            </strong>
          </div>
        </div>
      </section>
    </div>
  );
};
